import React, { useState, useContext } from "react"
import { graphql, Link } from "gatsby"
import { GatsbyImage, StaticImage } from "gatsby-plugin-image"
import FavoriteContext from "../context/FavoriteContext"

import Layout from "../components/layout"
import Sidebar from "../components/sidebar"
import Breadcrumb from "../components/breadcrumb"
import RelatedPosts from "../components/relatedPosts"
import Comments from "../components/comments"
import ModalWindow from "../components/modal"

import AdsenseMultiplex from "../components/ads/adsenseMultiplex"
import AdsenseTop from "../components/ads/adsenseTop"
import AdsenseBottom from "../components/ads/adsenseBottom"

import Seo from "../components/seo"
import Tooltip from "../components/UI/Tooltip"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faMapMarkerAlt,
  faPhoneAlt,
  faLink,
  faExternalLinkAlt,
  faExclamationTriangle,
  faComment,
  faArrowRight,
  faHeart as fasFaHeart,
} from "@fortawesome/free-solid-svg-icons"
import {
  faClock,
  faHeart as farFaHeart,
} from "@fortawesome/free-regular-svg-icons"

// 時間フォーマット
const timeFormat = (sec) => {
  let timestamp = sec * 1000
  let date = new Date(timestamp)
  let hours = date.getUTCHours()
  let minutes = date.getUTCMinutes()
  hours = ("0" + hours).slice(-2)
  minutes = ("0" + minutes).slice(-2)
  let formattedTime = hours + ":" + minutes
  return formattedTime
}

// 日時フォーマット
const dateFormat = (timestamp) => {
  let date = new Date(timestamp)
  let year = date.getFullYear()
  let month = ("0" + (date.getMonth() + 1)).slice(-2)
  let day = ("0" + date.getDate()).slice(-2)
  let formattedDate = year + "-" + month + "-" + day
  return formattedDate
}

// 現在の時間
let now = new Date()
let nowYear = now.getFullYear()
let nowMonth = ("0" + (now.getMonth() + 1)).slice(-2)
let nowDate = ("0" + now.getDate()).slice(-2)
let nowHours = ("0" + now.getHours()).slice(-2)
let nowMinutes = ("0" + now.getMinutes()).slice(-2)
let nowSecondes = now.getSeconds()

// 日本の祝日
const JapanHolidays = [
  "2025-01-01",
  "2025-01-13",
  "2025-02-11",
  "2025-02-23",
  "2025-02-24",
  "2025-03-20",
  "2025-04-29",
  "2025-05-03",
  "2025-05-04",
  "2025-05-05",
  "2025-05-06",
  "2025-07-21",
  "2025-08-11",
  "2025-09-15",
  "2025-09-23",
  "2025-10-13",
  "2025-11-03",
  "2025-11-23",
  "2025-11-24"
]
const today = nowYear + "-" + nowMonth + "-" + nowDate

const nowDayOfWeek = JapanHolidays.includes(today) ? 7 : now.getDay()

const SinglePost = ({ data, location }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false)

  const openModalHandler = () => {
    setModalIsOpen(true)
  }

  const closeModalHandler = () => {
    setModalIsOpen(false)
  }

  // お気に入り用のデータ
  const value = {
    id: data.entry.fields.slug,
    fields: {
      slug: data.entry.fields.slug,
    },
    featuredImage: data.entry.featuredImage ?? null,
    frontmatter: {
      title: data.entry.frontmatter.title,
      addressRegion: data.entry.frontmatter.addressRegion,
      addressLocality: data.entry.frontmatter.addressLocality,
      streetAddress: data.entry.frontmatter.streetAddress,
    },
    comments: {
      rating: data.entry.comments.rating,
    },
    excerpt: data.entry.frontmatter.excerpt,
  }

  const ctx = useContext(FavoriteContext)

  const favoriteHandler = () => {
    if (!ctx.isFavorite) {
      ctx.addFavorite(value)
    } else {
      ctx.removeFavorite(value.id)
    }
  }

  // 営業時間判定
  const mondayOpen = data.entry.frontmatter?.shopHours?.Monday
    ? timeFormat(data.entry.frontmatter.shopHours.Monday.open)
    : null
  const mondayClose = data.entry.frontmatter?.shopHours?.Monday
    ? timeFormat(data.entry.frontmatter.shopHours.Monday.close)
    : null
  const tuesdayOpen = data.entry.frontmatter?.shopHours?.Tuesday
    ? timeFormat(data.entry.frontmatter.shopHours.Tuesday.open)
    : null
  const tuesdayClose = data.entry.frontmatter?.shopHours?.Tuesday
    ? timeFormat(data.entry.frontmatter.shopHours.Tuesday.close)
    : null
  const wednesdayOpen = data.entry.frontmatter?.shopHours?.Wednesday
    ? timeFormat(data.entry.frontmatter.shopHours.Wednesday.open)
    : null
  const wednesdayClose = data.entry.frontmatter?.shopHours?.Wednesday
    ? timeFormat(data.entry.frontmatter.shopHours.Wednesday.close)
    : null
  const thursdayOpen = data.entry.frontmatter?.shopHours?.Thursday
    ? timeFormat(data.entry.frontmatter.shopHours.Thursday.open)
    : null
  const thursdayClose = data.entry.frontmatter?.shopHours?.Thursday
    ? timeFormat(data.entry.frontmatter.shopHours.Thursday.close)
    : null
  const fridayOpen = data.entry.frontmatter?.shopHours?.Friday
    ? timeFormat(data.entry.frontmatter.shopHours.Friday.open)
    : null
  const fridayClose = data.entry.frontmatter?.shopHours?.Friday
    ? timeFormat(data.entry.frontmatter.shopHours.Friday.close)
    : null
  const saturdayOpen = data.entry.frontmatter?.shopHours?.Saturday
    ? timeFormat(data.entry.frontmatter.shopHours.Saturday.open)
    : null
  const saturdayClose = data.entry.frontmatter?.shopHours?.Saturday
    ? timeFormat(data.entry.frontmatter.shopHours.Saturday.close)
    : null
  const sundayOpen = data.entry.frontmatter?.shopHours?.Sunday
    ? timeFormat(data.entry.frontmatter.shopHours.Sunday.open)
    : null
  const sundayClose = data.entry.frontmatter?.shopHours?.Sunday
    ? timeFormat(data.entry.frontmatter.shopHours.Sunday.close)
    : null
  const holidayOpen = data.entry.frontmatter?.shopHours?.PublicHolidays
    ? timeFormat(data.entry.frontmatter.shopHours.PublicHolidays.open)
    : null
  const holidayClose = data.entry.frontmatter?.shopHours?.PublicHolidays
    ? timeFormat(data.entry.frontmatter.shopHours.PublicHolidays.close)
    : null

  const openingHours = [
    { open: sundayOpen, close: sundayClose },
    { open: mondayOpen, close: mondayClose },
    { open: tuesdayOpen, close: tuesdayClose },
    { open: wednesdayOpen, close: wednesdayClose },
    { open: thursdayOpen, close: thursdayClose },
    { open: fridayOpen, close: fridayClose },
    { open: saturdayOpen, close: saturdayClose },
    { open: holidayOpen, close: holidayClose },
  ]

  let isNowOpen = false

  // 今月の全ての○曜日取得
  const getDays = (day, months) => {
    let daysPerMonth = []
    let allDays = []
    for (let j = 0; j < months.length; j++) {
      daysPerMonth = []
      for (let i = 1; i <= 31; i++) {
        const tmpDate = new Date(nowYear, months[j] - 1, i)
        if (months[j] - 1 !== tmpDate.getMonth()) break //月代わりで処理終了
        if (tmpDate.getDay() !== day) continue //引数に指定した曜日以外の時は何もしない
        daysPerMonth.push(
          tmpDate.getFullYear() +
            "-" +
            ("0" + (tmpDate.getMonth() + 1)).slice(-2) +
            "-" +
            ("0" + tmpDate.getDate()).slice(-2)
        )
      }
      allDays.push(daysPerMonth)
    }
    return allDays
  }

  const getShopHolidays = (day, months, weeks) => {
    const holidays = getDays(day, months)
    let allHolidays = []
    for (let i = 0; i < holidays.length; i++) {
      const specifiedDays = holidays[i].filter((v, j) => weeks.includes(j + 1))
      allHolidays = allHolidays.concat(specifiedDays)
    }
    return allHolidays
  }

  const shopHolidays =
    data.entry.frontmatter.shopHolidays !== null
      ? getShopHolidays(
          data.entry.frontmatter.shopHolidays.day,
          data.entry.frontmatter.shopHolidays.months,
          data.entry.frontmatter.shopHolidays.weeks
        )
      : [null]

  if (
    data.entry.frontmatter.shopHolidaysEx &&
    today >= dateFormat(Number(data.entry.frontmatter.shopHolidaysEx.start)) &&
    today <= dateFormat(Number(data.entry.frontmatter.shopHolidaysEx.end))
  ) {
    isNowOpen = false
  } else if (
    openingHours[nowDayOfWeek].open + ":00" <
      nowHours + ":" + nowMinutes + ":" + nowSecondes &&
    nowHours + ":" + nowMinutes + ":" + nowSecondes <
      openingHours[nowDayOfWeek].close + ":59" &&
    !shopHolidays.includes(today)
  ) {
    isNowOpen = true
  }

  return (
    <>
      <Layout>
        <div id="content" className="l-content" data-sidebar="on">
          <Breadcrumb
            title={data.entry.frontmatter.title}
            cat0={data.entry.frontmatter.categories[0]}
            cat1={data.entry.frontmatter.categories[1]}
          />
          <div className="l-content__body l-container">
            <main id="main_content" className="l-main l-article">
              <article className="l-main__body p-entry">
                <header className="p-entry__head">
                  {data.entry.frontmatter.tags?.[0].slug === "closed" && (
                    <span className="badge bg-danger">掲載終了</span>
                  )}
                  {data.entry.frontmatter.tags?.[0].slug === "reference" && (
                    <span className="badge bg-warning">参考情報</span>
                  )}
                  <div className="p-entry__title c-pageTitle shop-title">
                    <h1 className="c-pageTitle__main">
                      {data.entry.frontmatter.title}
                      {data.entry.frontmatter.shopYomi && (
                        <span>{data.entry.frontmatter.shopYomi}</span>
                      )}
                    </h1>
                    <button
                      className="btn-fav"
                      type="button"
                      onClick={favoriteHandler}
                    >
                      {ctx.isFavorite ? (
                        <span data-nosnippet>
                          <FontAwesomeIcon icon={fasFaHeart} />
                          保存済み
                        </span>
                      ) : (
                        <span data-nosnippet>
                          <FontAwesomeIcon icon={farFaHeart} />
                          保存する
                        </span>
                      )}
                    </button>
                    {data.master.frontmatter?.shopCompany && (
                      <p
                        className="text-gray small"
                        style={{ margin: "0 0 .25rem" }}
                      >
                        {data.master.frontmatter.shopCompany}
                      </p>
                    )}
                    <a href="#comments" className="p-rating">
                      <div className="p-rating_avarage">
                        {data.entry.comments.length > 0 && (
                          <span
                            className="p-rating_avarage-stars"
                            style={{
                              width:
                                (data.entry.comments.reduce(
                                  (sum, i) => sum + i.rating,
                                  0
                                ) /
                                  data.entry.comments.length) *
                                  20 +
                                "%",
                            }}
                          />
                        )}
                      </div>
                      <span className="p-rating_avarage-num">
                        {data.entry.comments.length}レビュー
                      </span>
                    </a>
                  </div>
                </header>
                <div className="shop-data">
                  <dl className="shop-data_info">
                    <div>
                      <dt>
                        <FontAwesomeIcon icon={faMapMarkerAlt} />
                        <span className="sr-only">住所</span>
                      </dt>
                      <dd>
                        {data.entry.frontmatter.tags?.[0].slug === "closed" ? (
                          <s>
                            {data.entry.frontmatter.addressRegion}
                            {data.entry.frontmatter.addressLocality}
                            {data.entry.frontmatter.streetAddress}
                            {data.entry.frontmatter.addressBuilding &&
                              ` ${data.entry.frontmatter.addressBuilding}`}
                          </s>
                        ) : (
                          <>
                            {data.entry.frontmatter.addressRegion}
                            {data.entry.frontmatter.addressLocality}
                            {data.entry.frontmatter.streetAddress}
                            {data.entry.frontmatter.addressBuilding &&
                              ` ${data.entry.frontmatter.addressBuilding}`}
                            {data.entry.frontmatter.categories[0].slug !==
                              "online" && (
                              <span style={{ display: "inline-block" }}>
                                {"("}
                                <button
                                  onClick={openModalHandler}
                                  type="button"
                                >
                                  地図で見る
                                </button>
                                {")"}
                              </span>
                            )}
                          </>
                        )}
                      </dd>
                    </div>
                    {data.entry.frontmatter.telephone && (
                      <div>
                        <dt>
                          <FontAwesomeIcon icon={faPhoneAlt} />
                          <span className="sr-only">電話番号</span>
                        </dt>
                        <dd>
                          {data.entry.frontmatter.tags?.[0].slug ===
                          "closed" ? (
                            <s>
                              {data.entry.frontmatter.telephone}
                              {data.entry.frontmatter.telephoneNote && (
                                <span
                                  className="text-gray"
                                  dangerouslySetInnerHTML={{
                                    __html: `(${data.entry.frontmatter.telephoneNote})`,
                                  }}
                                />
                              )}
                            </s>
                          ) : (
                            <>
                              {data.entry.frontmatter.telephone}
                              {data.entry.frontmatter.telephoneNote && (
                                <span
                                  className="text-gray"
                                  dangerouslySetInnerHTML={{
                                    __html: ` (${data.entry.frontmatter.telephoneNote})`,
                                  }}
                                />
                              )}
                            </>
                          )}
                        </dd>
                      </div>
                    )}
                    {data.entry.frontmatter.tags?.[0].slug !== "closed" &&
                      (data.entry.frontmatter.shopHours ||
                        data.entry.frontmatter.shopNote) && (
                        <div>
                          <dt>
                            <FontAwesomeIcon icon={faClock} />
                            <span className="sr-only">営業時間</span>
                          </dt>
                          <dd>
                            {data.entry.frontmatter.shopHours && (
                              <Tooltip
                                buttonName={
                                  isNowOpen ? (
                                    <>
                                      <b>営業中</b>{" "}
                                      {openingHours[nowDayOfWeek].open.replace(
                                        /(^)(0)/,
                                        ""
                                      )}
                                      -
                                      {openingHours[nowDayOfWeek].close.replace(
                                        /(^)(0)/,
                                        ""
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      <b>準備中</b> 営業時間を表示
                                    </>
                                  )
                                }
                              >
                                <ul>
                                  {openingHours.map((hours, i) => (
                                    <li key={i}>
                                      {i === 0 && (
                                        <span className="text-danger">日</span>
                                      )}
                                      {i === 1 && <span>月</span>}
                                      {i === 2 && <span>火</span>}
                                      {i === 3 && <span>水</span>}
                                      {i === 4 && <span>木</span>}
                                      {i === 5 && <span>金</span>}
                                      {i === 6 && (
                                        <span className="text-blue">土</span>
                                      )}
                                      {i === 7 && (
                                        <span className="text-danger">祝</span>
                                      )}
                                      <span>
                                        {hours.open !== null &&
                                        hours.close !== null
                                          ? hours.open.replace(/(^)(0)/, "") +
                                            "-" +
                                            hours.close.replace(/(^)(0)/, "")
                                          : "定休日"}
                                      </span>
                                    </li>
                                  ))}
                                </ul>
                              </Tooltip>
                            )}
                            {data.entry.frontmatter.shopNote && (
                              <span
                                className="text-gray"
                                dangerouslySetInnerHTML={{
                                  __html: ` (${data.entry.frontmatter.shopNote})`,
                                }}
                              />
                            )}
                          </dd>
                        </div>
                      )}
                    {data.master.frontmatter.shopUrl1 !== null && (
                      <div>
                        <dt>
                          <FontAwesomeIcon icon={faLink} />
                          <span className="sr-only">リンク</span>
                        </dt>
                        {data.master.frontmatter.shopUrl1.type === "normal" && (
                          <dd>
                            {data.entry.frontmatter.tags?.[0].slug ===
                            "closed" ? (
                              <s>
                                <a
                                  href={data.master.frontmatter.shopUrl1.url}
                                  target="_blank"
                                  rel="nofollow noreferrer noopener"
                                >
                                  公式サイト
                                </a>
                              </s>
                            ) : (
                              <a
                                href={data.master.frontmatter.shopUrl1.url}
                                target="_blank"
                                rel="nofollow noreferrer noopener"
                              >
                                公式サイト
                              </a>
                            )}
                          </dd>
                        )}
                        {!["aff-t", "normal"].includes(
                          data.master.frontmatter.shopUrl1.type
                        ) && (
                          <dd>
                            {data.entry.frontmatter.tags?.[0].slug ===
                            "closed" ? (
                              <s>
                                <a
                                  href={data.master.frontmatter.shopUrl1.url}
                                  target="_blank"
                                  rel="nofollow noreferrer noopener"
                                >
                                  {data.master.frontmatter.shopUrl1.type
                                    .charAt(0)
                                    .toUpperCase() +
                                    data.master.frontmatter.shopUrl1.type.slice(
                                      1
                                    )}
                                </a>
                              </s>
                            ) : (
                              <a
                                href={data.master.frontmatter.shopUrl1.url}
                                target="_blank"
                                rel="nofollow noreferrer noopener"
                              >
                                {data.master.frontmatter.shopUrl1.type
                                  .charAt(0)
                                  .toUpperCase() +
                                  data.master.frontmatter.shopUrl1.type.slice(
                                    1
                                  )}
                              </a>
                            )}
                          </dd>
                        )}
                        {data.master.frontmatter.shopUrl1.type === "aff-t" &&
                          (data.entry.frontmatter.tags?.[0].slug ===
                          "closed" ? (
                            <s>
                              <dd
                                dangerouslySetInnerHTML={{
                                  __html: `${data.master.frontmatter.shopUrl1.url}`,
                                }}
                              />
                            </s>
                          ) : (
                            <dd
                              dangerouslySetInnerHTML={{
                                __html: `${data.master.frontmatter.shopUrl1.url}`,
                              }}
                            />
                          ))}
                      </div>
                    )}
                  </dl>
                  <figure className="shop-data_img">
                    {data.entry.featuredImage.childImageSharp ? (
                      <GatsbyImage
                        image={
                          data.entry.featuredImage.childImageSharp
                            .gatsbyImageData
                        }
                        alt={data.entry.frontmatter.title}
                      />
                    ) : (
                      <StaticImage
                        src="../images/noimg.png"
                        alt="No image"
                        placeholder="blurred"
                        width={640}
                        height={640}
                      />
                    )}
                    {data.entry.featuredImage.childImageSharp && (
                      <figcaption>
                        画像引用元 : {data.master.frontmatter.title}
                      </figcaption>
                    )}
                  </figure>
                  <div className="table-price">
                    <table className="table">
                      {data.xlsx && (
                        <caption className="text-gray small">
                          注文枚数と1枚あたりの税込価格の目安
                          {data.xlsx.p_note && (
                            <span
                              dangerouslySetInnerHTML={{
                                __html: `(${data.xlsx.p_note}) `,
                              }}
                            />
                          )}
                          ※{data.xlsx.dateJP}
                          時点。価格の計算方法については
                          <Link to={`/price-calculation/`}>こちら</Link>
                        </caption>
                      )}
                      {data.xlsx ? (
                        <tbody>
                          <tr>
                            <th>1枚</th>
                            <td>
                              {data.xlsx._001 < 99999 ? (
                                `@\xA5${data.xlsx._001.toLocaleString()}~`
                              ) : (
                                <span className="text-gray">問合せ</span>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th>10枚</th>
                            <td>
                              {data.xlsx._010 < 99999 ? (
                                `@\xA5${data.xlsx._010.toLocaleString()}~`
                              ) : (
                                <span className="text-gray">問合せ</span>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th>30枚</th>
                            <td>
                              {data.xlsx._030 < 99999 ? (
                                `@\xA5${data.xlsx._030.toLocaleString()}~`
                              ) : (
                                <span className="text-gray">問合せ</span>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th>50枚</th>
                            <td>
                              {data.xlsx._050 < 99999 ? (
                                `@\xA5${data.xlsx._050.toLocaleString()}~`
                              ) : (
                                <span className="text-gray">問合せ</span>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th>100枚</th>
                            <td>
                              {data.xlsx._100 < 99999 ? (
                                `@\xA5${data.xlsx._100.toLocaleString()}~`
                              ) : (
                                <span className="text-gray">問合せ</span>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        <tbody>
                          <tr>
                            <th>1枚</th>
                            <td rowSpan={5}>プリント価格情報なし</td>
                          </tr>
                          <tr>
                            <th>10枚</th>
                          </tr>
                          <tr>
                            <th>30枚</th>
                          </tr>
                          <tr>
                            <th>50枚</th>
                          </tr>
                          <tr>
                            <th>100枚</th>
                          </tr>
                        </tbody>
                      )}
                    </table>
                  </div>
                  <div className="table-design">
                    <table className="table">
                      <tbody>
                        {data.xlsx && (
                          <tr>
                            <th>送料</th>
                            <td>
                              {data.xlsx.s_price > 0 &&
                                (data.xlsx.s_price !== 999999
                                  ? `\xA5${data.xlsx.s_price.toLocaleString()}`
                                  : "不明")}
                              {data.xlsx.s_price === 0 &&
                                data.xlsx.s_other !== "料金に込み" &&
                                "\xA50"}
                              {data.xlsx.s_other &&
                                (data.xlsx.s_other === "~" ? (
                                  "~"
                                ) : data.xlsx.s_other === "料金に込み" ? (
                                  <span>{data.xlsx.s_other}</span>
                                ) : (
                                  <span className="text-gray small">
                                    {`\u0020${data.xlsx.s_other}`}
                                  </span>
                                ))}
                              {data.xlsx.s_note && (
                                <p
                                  className="text-gray small"
                                  dangerouslySetInnerHTML={{
                                    __html: `${data.xlsx.s_note}`,
                                  }}
                                />
                              )}
                            </td>
                          </tr>
                        )}
                        {(data.master.frontmatter.designSupport === true ||
                          data.master.frontmatter.designPrice !== null ||
                          (data.entry.frontmatter.tags &&
                            data.entry.frontmatter.tags.findIndex(
                              ({ slug }) => slug === "design-tool"
                            ) > -1)) && (
                          <tr>
                            <th className="table-light">デザイン</th>
                            <td>
                              {data.master.frontmatter.designSupport === true &&
                                "サポートあり"}
                              {data.master.frontmatter.designPrice && (
                                <p
                                  className="text-gray small"
                                  dangerouslySetInnerHTML={{
                                    __html: `${data.master.frontmatter.designPrice}`,
                                  }}
                                />
                              )}
                              {data.entry.frontmatter.tags &&
                                data.entry.frontmatter.tags.findIndex(
                                  ({ slug }) => slug === "design-tool"
                                ) > -1 && (
                                  <span className="badge bg-danger">
                                    WEBデザインツールあり
                                  </span>
                                )}
                            </td>
                          </tr>
                        )}
                        {data.master.frontmatter.designData !== null && (
                          <tr>
                            <th>データ入稿</th>
                            <td>
                              <ul>
                                {data.master.frontmatter.designData.map(
                                  (node, i) => (
                                    <li key={i}>
                                      <i className={`icon-file ${node}`} />
                                    </li>
                                  )
                                )}
                              </ul>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                {data.entry.frontmatter.shopPriority > 2 && (
                  <p
                    style={{
                      color: "gray",
                      fontStyle: "italic",
                      fontSize: "0.8em",
                    }}
                  >
                    外部サイトへのリンクにはアフィリエイトタグが含まれている場合があり、購入や会員登録の成約などから当サイトが収益化を行うことがあります。詳細は
                    <Link to="/privacy-policy/">プライバシーポリシー</Link>
                    をご確認ください。
                  </p>
                )}

                {data.entry.frontmatter.excerpt && (
                  <section
                    className={`shop-card ${
                      data.entry.frontmatter.tags?.[0].slug === "closed"
                        ? "bg-pink"
                        : "bg-beige"
                    }`}
                  >
                    {data.entry.frontmatter.tags?.[0].slug === "reference" && (
                      <h2 className="shop-card_header text-warning">
                        <FontAwesomeIcon icon={faExclamationTriangle} />
                        こちらは参考情報です
                      </h2>
                    )}
                    {data.entry.frontmatter.tags?.[0].slug === "closed" && (
                      <h2 className="shop-card_header text-danger">
                        <FontAwesomeIcon icon={faExclamationTriangle} />
                        掲載を終了しています
                      </h2>
                    )}
                    <div
                      className="shop-card_text"
                      dangerouslySetInnerHTML={{
                        __html: `${data.entry.frontmatter.excerpt}`,
                      }}
                    />
                  </section>
                )}

                {data.master.wordCount.paragraphs !== null && (
                  <section className="shop-card bg-lightblue">
                    <h2 className="shop-card_header text-blue">
                      <FontAwesomeIcon icon={faComment} /> お店からのコメント
                    </h2>
                    <div
                      className="shop-card_body"
                      dangerouslySetInnerHTML={{
                        __html: `${data.master.html}`,
                      }}
                    />
                  </section>
                )}

                <AdsenseTop path={location.pathname} />

                <div
                  className="c-postContent p-entry__content"
                  dangerouslySetInnerHTML={{
                    __html: `<h2>こんなショップです</h2>${data.entry.html}`,
                  }}
                />
                {data.entry.frontmatter.shopPriority < 5 && (
                  <AdsenseBottom path={location.pathname} />
                )}

                <footer className="p-entry__foot u-mt-10">
                  <div className="c-postMetas u-flex--aicw">
                    <div className="c-postTimes u-flex--aicw">
                      <time
                        className="c-postTimes__item u-flex--aic -modified"
                        dateTime={data.entry.frontmatter.lastmod}
                      >
                        最終更新日 : {data.entry.frontmatter.lastmodJP}
                      </time>
                    </div>
                  </div>
                  <div className="c-postMetas u-flex--aicw">
                    <div className="c-postTerms__item -tag u-flex--aicw">
                      {data.entry.frontmatter.tags?.map((node) => (
                        <Link
                          className="c-postTerms__link"
                          to={`/tag/${node.slug}/`}
                          key={node.id}
                        >
                          &#35;{node.title}
                        </Link>
                      ))}
                    </div>
                  </div>
                  <div className="p-entry__foot_btn">
                    {data.master.frontmatter.shopUrl1 !== null &&
                      (data.master.frontmatter.shopUrl1.type !== "aff-t" ? (
                        <a
                          href={data.master.frontmatter.shopUrl1.url}
                          target="_blank"
                          rel="nofollow noreferrer noopener"
                          className={`shop-btn ${
                            data.master.frontmatter.shopSogo
                              ? "shop-btn-red"
                              : "shop-btn-normal"
                          }`}
                        >
                          {data.master.frontmatter.title}へ行く
                          <FontAwesomeIcon icon={faExternalLinkAlt} />
                        </a>
                      ) : (
                        <span
                          className="shop-btn-af"
                          dangerouslySetInnerHTML={{
                            __html: `${data.master.frontmatter.shopUrl2.url}`,
                          }}
                        />
                      ))}
                    <button
                      className="btn-fav shop-btn-fav"
                      onClick={favoriteHandler}
                      type="button"
                    >
                      {ctx.isFavorite ? (
                        <span data-nosnippet>
                          <FontAwesomeIcon icon={fasFaHeart} />
                          お気に入りに保存済み
                        </span>
                      ) : (
                        <span data-nosnippet>
                          <FontAwesomeIcon icon={farFaHeart} />
                          お気に入りに保存する
                        </span>
                      )}
                    </button>
                    <Link to="/favorite/">お気に入り保存済みリストを見る</Link>
                    <p className="u-mb-10">
                      <small className="text-gray">
                        ※お気に入りシステムはブラウザの標準機能を利用しており、登録不要で今すぐご利用いただけます。
                      </small>
                    </p>
                  </div>
                </footer>

                <section className="p-entry__related c-bottomSection">
                  <h2 className="c-bottomSection__title">
                    {data.entry.frontmatter.categories[0].slug === "online" ? (
                      <>通販専門</>
                    ) : data.related1.totalCount > 1 ? (
                      <>{data.entry.frontmatter.categories[1].title}周辺</>
                    ) : (
                      <>{data.entry.frontmatter.categories[0].title}</>
                    )}
                    のプリントショップ
                  </h2>
                  <p className="u-ta-r u-mb-10">
                    {data.entry.frontmatter.categories[0].slug === "online" ? (
                      <Link to={`/area/online/`}>
                        すべて見る <FontAwesomeIcon icon={faArrowRight} />
                      </Link>
                    ) : data.related1.totalCount > 1 ? (
                      <Link
                        to={`/area/${data.entry.frontmatter.categories[0].slug}/${data.entry.frontmatter.categories[1].slug}/`}
                      >
                        すべて見る <FontAwesomeIcon icon={faArrowRight} />
                      </Link>
                    ) : (
                      <Link
                        to={`/area/${data.entry.frontmatter.categories[0].slug}/`}
                      >
                        すべて見る <FontAwesomeIcon icon={faArrowRight} />
                      </Link>
                    )}
                  </p>
                  <RelatedPosts
                    related0={data.related0}
                    related1={data.related1}
                  />
                  <AdsenseMultiplex path={location.pathname} />
                </section>

                <Comments
                  title={data.entry.frontmatter.title}
                  commentOpen={data.entry.frontmatter.commentOpen}
                  slug={data.entry.fields.slug}
                  comments={data.entry.comments}
                />
              </article>
            </main>
            <Sidebar />
          </div>
        </div>
      </Layout>
      <ModalWindow isOpen={modalIsOpen} closeModal={closeModalHandler}>
        <iframe
          src={`https://www.google.com/maps/embed/v1/place?key=${process.env.GATSBY_GOOGLE_MAP}&q=place_id:${data.entry.frontmatter.placeID}`}
          title="iframe map"
          className="iframeMap"
          loading="lazy"
        />
      </ModalWindow>
    </>
  )
}

export default SinglePost

export const Head = ({ data, location }) => {
  const schema = [
    {
      "@type": "WebPage",
      "@id": `${data.site.siteMetadata.siteUrl}/companies/${data.entry.fields.slug}/`,
      url: `${data.site.siteMetadata.siteUrl}/companies/${data.entry.fields.slug}/`,
      name: `${data.entry.frontmatter.title} - ${data.site.siteMetadata.title}`,
      isPartOf: { "@id": `${data.site.siteMetadata.siteUrl}/#website` },
      datePublished: data.entry.frontmatter.date,
      dateModified: data.entry.frontmatter.lastmod,
      breadcrumb: {
        "@id": `${data.site.siteMetadata.siteUrl}/companies/${data.entry.fields.slug}/#breadcrumb`,
      },
      inLanguage: "ja",
      potentialAction: [
        {
          "@type": "ReadAction",
          target: [
            `${data.site.siteMetadata.siteUrl}/companies/${data.entry.fields.slug}/`,
          ],
        },
      ],
    },
    {
      "@type": "BreadcrumbList",
      "@id": `${data.site.siteMetadata.siteUrl}/companies/${data.entry.fields.slug}/#breadcrumb`,
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: data.entry.frontmatter.categories[0].title,
          item: `${data.site.siteMetadata.siteUrl}/area/${data.entry.frontmatter.categories[0].slug}/`,
        },
        data.entry.frontmatter.categories[1] && {
          "@type": "ListItem",
          position: 2,
          name: data.entry.frontmatter.categories[1].title,
          item: `${data.site.siteMetadata.siteUrl}/area/${data.entry.frontmatter.categories[0].slug}/${data.entry.frontmatter.categories[1].slug}/`,
        },
        {
          "@type": "ListItem",
          position: data.entry.frontmatter.categories[1] ? 3 : 2,
          name: data.entry.frontmatter.title,
        },
      ],
    },
    {
      "@type": "Article",
      "@id": `${data.site.siteMetadata.siteUrl}/companies/${data.entry.fields.slug}/#article`,
      isPartOf: {
        "@id": `${data.site.siteMetadata.siteUrl}/companies/${data.entry.fields.slug}/`,
      },
      author: {
        name: "tshirt-admin",
        "@id": `${data.site.siteMetadata.siteUrl}/#/schema/#person`,
      },
      headline: data.entry.frontmatter.title,
      datePublished: data.entry.frontmatter.date,
      dateModified: data.entry.frontmatter.lastmod,
      mainEntityOfPage: {
        "@id": `${data.site.siteMetadata.siteUrl}/companies/${data.entry.fields.slug}/`,
      },
      wordCount: data.entry.html.toString().replace(/(<([^>]+)>)/gi, "").length,
      commentCount: data.entry.comments.length,
      publisher: { "@id": `${data.site.siteMetadata.siteUrl}/#organization` },
      keywords: data.entry.frontmatter.tags?.map((tag) => tag.title),
      articleSection: data.entry.frontmatter.categories.map((cat) => cat.title),
      inLanguage: "ja",
      potentialAction: [
        {
          "@type": "CommentAction",
          name: "Comment",
          target: [
            `${data.site.siteMetadata.siteUrl}/companies/${data.entry.fields.slug}/#respond`,
          ],
        },
      ],
      image: {
        "@type": "ImageObject",
        inLanguage: "ja",
        "@id": data.entry.featuredImage?.id || data.fileNoimg.id,
        url:
          data.site.siteMetadata.siteUrl +
          (data.entry.featuredImage?.childImageSharp?.original?.src ||
            data.site.siteMetadata.siteUrl + data.fileNoimg.publicURL),
        contentUrl:
          data.site.siteMetadata.siteUrl +
          (data.entry.featuredImage?.childImageSharp?.original?.src ||
            data.fileNoimg.childImageSharp.original.src),
        width:
          data.entry.featuredImage?.childImageSharp?.original?.width ||
          data.fileNoimg.childImageSharp.original.width,
        height:
          data.entry.featuredImage?.childImageSharp?.original?.height ||
          data.fileNoimg.childImageSharp.original.height,
      },
    },
    {
      "@type": "Person",
      "@id": `${data.site.siteMetadata.siteUrl}/#/schema/#person`,
      name: "tshirt-admin",
      image: {
        "@type": "ImageObject",
        inLanguage: "ja",
        "@id": `${data.site.siteMetadata.siteUrl}/#/schema/person/image/`,
        url: data.site.siteMetadata.siteUrl + data.fileIcon.publicURL,
        contentUrl: data.site.siteMetadata.siteUrl + data.fileIcon.publicURL,
        caption: "tshirt-admin",
      },
      sameAs: ["https://twitter.com/tshirt_kakaku"],
    },
    {
      "@type": "Store",
      name: data.entry.frontmatter.title,
      image: {
        "@type": "ImageObject",
        url:
          data.site.siteMetadata.siteUrl +
          (data.entry.featuredImage?.childImageSharp?.original?.src ||
            data.fileNoimg.publicURL),
        width:
          data.entry.featuredImage?.childImageSharp?.original?.width ||
          data.fileNoimg.childImageSharp.original.width,
        height:
          data.entry.featuredImage?.childImageSharp?.original?.height ||
          data.fileNoimg.childImageSharp.original.height,
      },
      telephone: data.entry.frontmatter.telephone,
      address: {
        "@type": "PostalAddress",
        streetAddress: data.entry.frontmatter.streetAddress,
        addressLocality: data.entry.frontmatter.addressLocality,
        postalCode: data.entry.frontmatter.postalCode,
        addressRegion: data.entry.frontmatter.addressRegion,
        addressCountry: "JP",
      },
      aggregateRating:
        data.entry.comments.reduce((sum, i) => sum + i.rating, 0) > 0
          ? {
              "@type": "AggregateRating",
              ratingValue: (
                data.entry.comments.reduce((sum, i) => sum + i.rating, 0) /
                data.entry.comments.length
              ).toFixed(1),
              reviewCount: data.entry.comments.length,
            }
          : null,
      openingHoursSpecification:
        data.entry.frontmatter.shopHours !== null
          ? [
              data.entry.frontmatter.shopHours.Monday && {
                "@type": "OpeningHoursSpecification",
                dayOfWeek: "Monday",
                opens: timeFormat(data.entry.frontmatter.shopHours.Monday.open),
                closes: timeFormat(
                  data.entry.frontmatter.shopHours.Monday.close
                ),
              },
              data.entry.frontmatter.shopHours.Tuesday && {
                "@type": "OpeningHoursSpecification",
                dayOfWeek: "Tuesday",
                opens: timeFormat(
                  data.entry.frontmatter.shopHours.Tuesday.open
                ),
                closes: timeFormat(
                  data.entry.frontmatter.shopHours.Tuesday.close
                ),
              },
              data.entry.frontmatter.shopHours.Wednesday && {
                "@type": "OpeningHoursSpecification",
                dayOfWeek: "Wednesday",
                opens: timeFormat(
                  data.entry.frontmatter.shopHours.Wednesday.open
                ),
                closes: timeFormat(
                  data.entry.frontmatter.shopHours.Wednesday.close
                ),
              },
              data.entry.frontmatter.shopHours.Thursday && {
                "@type": "OpeningHoursSpecification",
                dayOfWeek: "Thursday",
                opens: timeFormat(
                  data.entry.frontmatter.shopHours.Thursday.open
                ),
                closes: timeFormat(
                  data.entry.frontmatter.shopHours.Thursday.close
                ),
              },
              data.entry.frontmatter.shopHours.Friday && {
                "@type": "OpeningHoursSpecification",
                dayOfWeek: "Friday",
                opens: timeFormat(data.entry.frontmatter.shopHours.Friday.open),
                closes: timeFormat(
                  data.entry.frontmatter.shopHours.Friday.close
                ),
              },
              data.entry.frontmatter.shopHours.Saturday && {
                "@type": "OpeningHoursSpecification",
                dayOfWeek: "Saturday",
                opens: timeFormat(
                  data.entry.frontmatter.shopHours.Saturday.open
                ),
                closes: timeFormat(
                  data.entry.frontmatter.shopHours.Saturday.close
                ),
              },
              data.entry.frontmatter.shopHours.PublicHolidays && {
                "@type": "OpeningHoursSpecification",
                dayOfWeek: "PublicHolidays",
                opens: timeFormat(
                  data.entry.frontmatter.shopHours.PublicHolidays.open
                ),
                closes: timeFormat(
                  data.entry.frontmatter.shopHours.PublicHolidays.close
                ),
              },
            ]
          : null,
    },
  ]

  return (
    <Seo
      pagetitle={`${data.entry.frontmatter.title}${
        data.entry.frontmatter.shopYomi
          ? " " + data.entry.frontmatter.shopYomi
          : ""
      } | ${
        data.entry.frontmatter.categories[0] === "通販専門"
          ? "通販専門"
          : data.entry.frontmatter.addressRegion +
            data.entry.frontmatter.addressLocality
      }`}
      pagedesc={data.entry.excerpt}
      pagepath={location.pathname}
      pagetype="article"
      pageimg={data.entry.featuredImage.childImageSharp?.original?.src}
      pageimgw={data.entry.featuredImage.childImageSharp?.original?.width}
      pageimgh={data.entry.featuredImage.childImageSharp?.original?.height}
      pageSchema={schema}
    />
  )
}

export const query = graphql`
  query (
    $id: String!
    $master_slug: String!
    $cat1_slug: String!
    $cat0_slug: String!
  ) {
    entry: markdownRemark(
      id: { eq: $id }
      fields: { type: { eq: "company" } }
    ) {
      id
      html
      excerpt(pruneLength: 100, truncate: true)
      fields {
        slug
      }
      frontmatter {
        title
        categories {
          title
          slug
        }
        tags {
          title
          slug
          id
        }
        excerpt
        shopYomi
        shopPriority
        postalCode
        addressRegion
        addressLocality
        streetAddress
        addressBuilding
        telephone
        telephoneNote
        shopHours {
          Sunday {
            open
            close
          }
          Monday {
            open
            close
          }
          Tuesday {
            open
            close
          }
          Wednesday {
            open
            close
          }
          Thursday {
            open
            close
          }
          Friday {
            open
            close
          }
          Saturday {
            open
            close
          }
          PublicHolidays {
            open
            close
          }
        }
        shopHolidays {
          day
          months
          weeks
        }
        shopHolidaysEx {
          start
          end
        }
        shopNote
        lat
        lng
        placeID
        commentOpen
        date
        lastmod
        lastmodJP: lastmod(formatString: "yyyy年M月D日")
      }
      featuredImage {
        id
        childImageSharp {
          gatsbyImageData(width: 360, height: 360)
          original {
            src
            width
            height
          }
        }
      }
      comments {
        id
        name
        date
        dateReadable: date(fromNow: true, locale: "ja-JP")
        title
        rating
        message
      }
    }
    master: markdownRemark(
      fields: { type: { eq: "master" }, slug: { eq: $master_slug } }
    ) {
      html
      wordCount {
        paragraphs
      }
      frontmatter {
        title
        shopCompany
        shopSogo
        shopUrl1 {
          type
          url
        }
        shopUrl2 {
          type
          url
        }
        designPrice
        designSupport
        designData
      }
    }
    xlsx: priceXlsxLowest(slug: { eq: $master_slug }) {
      _001
      _010
      _030
      _050
      _100
      p_note
      s_price
      s_other
      s_note
      dateJP: date(formatString: "YYYY年M月D日")
    }
    related1: allMarkdownRemark(
      filter: {
        id: { ne: $id }
        fields: { type: { eq: "company" } }
        frontmatter: {
          tags: { elemMatch: { slug: { nin: ["closed", "reference"] } } }
          categories: { elemMatch: { slug: { eq: $cat1_slug } } }
          draft: { ne: true }
        }
      }
    ) {
      nodes {
        id
        featuredImage {
          childImageSharp {
            gatsbyImageData(width: 360, height: 360)
          }
        }
        fields {
          slug
        }
        frontmatter {
          title
          shopPriority
        }
        comments {
          id
          rating
        }
      }
      totalCount
    }
    related0: allMarkdownRemark(
      filter: {
        id: { ne: $id }
        fields: { type: { eq: "company" } }
        frontmatter: {
          tags: { elemMatch: { slug: { nin: ["closed", "reference"] } } }
          draft: { ne: true }
          categories: {
            elemMatch: { slug: { eq: $cat0_slug, ne: $cat1_slug } }
          }
        }
      }
    ) {
      nodes {
        id
        featuredImage {
          childImageSharp {
            gatsbyImageData(width: 360, height: 360)
          }
        }
        fields {
          slug
        }
        frontmatter {
          title
          shopPriority
        }
        comments {
          id
          rating
        }
      }
    }
    site {
      siteMetadata {
        siteUrl
        title
        description
      }
    }
    fileIcon: file(name: { eq: "icon" }) {
      publicURL
      childImageSharp {
        original {
          width
          height
        }
      }
    }
    fileNoimg: file(name: { eq: "noimg" }) {
      id
      childImageSharp {
        original {
          src
          width
          height
        }
      }
    }
  }
`
